import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

export type InvestorTokenAssetStatus = 'ALL' | 'ACTIVE' | 'COMPLETED' | 'CANCELLED' | 'LIQUIDATED'
export type SortOrder = 'ASC' | 'DESC'

export type InvestorTokenAsset = {
  id: string
  createdByAccountId?: string
  purchaseDate?: string
  tokensPurchased?: number
  principalNairaMajor?: number
  percentageReturnMonthly?: number
  termMonths?: number
  monthlyPaymentNairaMajor?: number
  monthsPaid?: number
  totalPaidOutNairaMajor?: number
  totalRemainingPayoutNairaMajor?: number
  nextPayoutDueAt?: string
  status?: 'ACTIVE' | 'CLOSED' | string
  shares?: Array<{
    accountId?: string
    tokenCountOwned?: number
  }>
  createdByUser?: {
    userId?: string
    firstName?: string
    lastName?: string
    msisdn?: string
    accountId?: string
    photo?: { url?: string }
  }
  createdAt?: string
  updatedAt?: string
  blockchainInfo?: {
    blockchainTxHash?: string
    blockchainBlockNumber?: number
    blockchainRegisteredAt?: string
  }
}

export type InvestorTokenAssetPayout = {
  id: string
  createdAt?: string
  updatedAt?: string
  investorTokenAssetId?: string
  investorTokenAsset?: InvestorTokenAsset
  periodNumber?: number
  payoutTotalNairaMajor?: number
  paidAt?: string
  breakdown?: string
}

export type InvestorTokenAssetInvestorSummary = {
  totalTokensOwned: number
  totalPrincipalInvestedNairaMajor: number
  totalActivePrincipalInvestedNairaMajor: number
  totalPaidOutNairaMajor: number
  activeAssetCount: number
  completedAssetCount: number
  cancelledAssetCount: number
  liquidatedAssetCount: number
  totalAssetCount: number
}

const investorTokenAssetsService = {
  list: async (params: {
    pageNumber: number
    pageSize: number
    sortOrder: SortOrder
    status: InvestorTokenAssetStatus
    accountId?: string
    id?: string
  }) => {
    const { pageNumber, pageSize, sortOrder, status, accountId, id } = params
    return await axios.get('/investor/token-assets', {
      params: {
        pageNumber,
        pageSize,
        sortOrder,
        status,
        ...(accountId ? { accountId } : {}),
        ...(id ? { id } : {}),
      },
    })
  },

  getSingle: async (tokenAssetId: string) => {
    return await axios.get(`/investor/token-assets/${tokenAssetId}`)
  },

  triggerPayout: async (tokenAssetId: string) => {
    return await axios.post(`/investor/token-assets/${tokenAssetId}/trigger-payout`)
  },

  listPayouts: async (params: {
    pageNumber: number
    pageSize: number
    sortOrder: SortOrder
    investorTokenAssetId: string | undefined
    periodNumber?: number
    id?: string
  }) => {
    const { pageNumber, pageSize, sortOrder, investorTokenAssetId, periodNumber, id } = params
    return await axios.get('/investor/token-assets/payouts', {
      params: {
        pageNumber,
        pageSize,
        sortOrder,
        investorTokenAssetId,
        ...(periodNumber != null ? { periodNumber } : {}),
        ...(id ? { id } : {}),
      },
    })
  },

  investorSummary: async (accountId: string) => {
    return await axios.get('/investor/token-assets/investor-summary', {
      params: {
        accountId,
      },
    })
  },
}

export default investorTokenAssetsService
